import { helper, only_when_authorised } from '.';
import * as calls from './calls';

export type JSONRPCAPI = ReturnType<typeof api_provider>;

export const api_provider = () => ({
    helper: helper,
    only_when_authorised: only_when_authorised,
    ...calls,
});
